// 只要符合校验规则条件就返回true
export const strategy = {
  // 非空校验
  'isNotEmpty': (value, correctMsg = '符合非空字段规则校验', errorMsg = '不符合非空字段规则校验') => {
    if (value === '') {
      return { msg: errorMsg, status: false }
    } else {
      return { msg: correctMsg, status: true }
    }
  },
  // 限制最小长度
  'minLengthCheck': (value, length, correctMsg = '符合最小长度规则校验', errorMsg = '不符合最小长度规则校验') => {
    if (value.length < length) {
      return { msg: errorMsg, status: false }
    } else {
      return { msg: correctMsg, status: true }
    }
  },
  // 限制最大长度
  'maxLengthCheck': (value, length, correctMsg = '符合最大长度规则校验', errorMsg = '不符合最大长度规则校验') => {
    if (value.length > length) {
      return { msg: errorMsg, status: false }
    } else {
      return { msg: correctMsg, status: true }
    }
  },
  // 手机号格式校验
  'phoneCheck': (phone, correctMsg = '符合手机号规则校验', errorMsg = '不符合手机号规则校验', emptyMsg = '不能为空') => {
    if (phone === '') {
      return { msg: emptyMsg, status: false }
    } else if (!/^(1[3-9])\d{9}$/.test(phone)) {
      return { msg: errorMsg, status: false }
    } else {
      return { msg: correctMsg, status: true }
    }
  },
  // 准考证号校验
  // 'admissionCheck': (admissionCode, correctMsg = '符合准考证号规则校验', errorMsg = '不符合准考证号规则校验', emptyMsg = '不能为空') => {
  //   if (admissionCode === '') {
  //     return { msg: emptyMsg, status: false }
  //   } else if (!/^\d{12}$/.test(admissionCode)) {
  //     return { msg: errorMsg, status: false }
  //   } else {
  //     return { msg: correctMsg, status: true }
  //   }
  // },
  // 密码格式及密码确认校验
  'pwdCheck': (pwd, correctMsg = '符合密码规则校验', errorMsg = '不符合密码规则校验', emptyMsg = '不能为空') => {
    if (pwd === '') {
      return { msg: emptyMsg, status: false }
    // } else if (!/^.{8,16}$/.test(pwd)) {
    } else if (!/(?=^.{8,16}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[a-zA-Z])(?=.*(_|-|@|!|#|\$|%|\^|&|\*|\(|\)|`|~|,|<|\.|>|\/|\?|;|:|'|"|{|\[|\]|}|=|\+|\.|\\)).*$/.test(pwd)) {
      return { msg: errorMsg, status: false }
    } else {
      return { msg: correctMsg, status: true }
    }

  },
  // 姓名格式校验
  // 'nameCheck': (name, correctMsg = '符合姓名规则校验', errorMsg = '不符合姓名规则校验', emptyMsg = '不能为空') => {
  //   if (name === '') {
  //     return { msg: emptyMsg, status: false }
  //   } else if (!/^[\u4e00-\u9fa5]{2,4}$/.test(name)) {
  //     return { msg: errorMsg, status: false }
  //   } else {
  //     return { msg: correctMsg, status: true }
  //   }
  // },
  // 邮箱格式校验
  'emailCheck': (email, correctMsg = '符合邮箱规则校验', errorMsg = '不符合邮箱规则校验', emptyMsg = '不能为空') => {
    if (email === '') {
      return { msg: emptyMsg, status: false }
    } else if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(email)) {
      return { msg: errorMsg, status: false }
    } else {
      return { msg: correctMsg, status: true }
    }
  },
  // 用户名格式校验
  'usernameCheck': (username, correctMsg = '符合用户名规则校验', errorMsg = '不符合用户名规则校验', emptyMsg = '不能为空') => {
    if (username === '') {
      return { msg: emptyMsg, status: false }
    } else if (!/^[A-Za-z0-9]{6,18}$/.test(username)) {
      return { msg: errorMsg, status: false }
    } else {
      return { msg: correctMsg, status: true }
    }
  },
  // 身份证号格式校验
  'idCardCodeCheck': (idCardCode, correctMsg = '符合身份证号规则校验', errorMsg = '不符合身份证号规则校验', emptyMsg = '不能为空') => {
    if (idCardCode === '') {
      return { msg: emptyMsg, status: false }
    } else if (!/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(idCardCode)) {
      return { msg: errorMsg, status: false }
    } else {
      return { msg: correctMsg, status: true }
    }
  },
  //QQ号的校验
  'qqCheck': (qq, length, correctMsg = '符合qq号规则校验', errorMsg = '不符合qq号规则校验', errorLengthMsg = '不符合qq号长度') => {
    if (qq === '') {
      return { msg: correctMsg, status: true }
    } else if (!/^[0-9]+.?[0-9]*$/.test(qq)) {
      return { msg: errorMsg, status: false }
    } else if (qq.length > length) {
      return { msg: errorLengthMsg, status: false }
    } else {
      return { msg: correctMsg, status: true }
    }
  },
  //姓名的校验
  'nameCheck': (name, length, correctMsg = '符合姓名规则校验', errorMsg = '不符合姓名长度', emptyMsg = '不能为空') => {
    if (name === '') {
      return { msg: emptyMsg, status: false }
    } else if (name.length > length) {
      return { msg: errorMsg, status: false }
    } else {
      return { msg: correctMsg, status: true }
    }
  },
  //准考证号的校验
  'admissionCheck': (admissionCard, length, correctMsg = '', errorMsg = '准考证号为纯数字', errorLengthMsg = '准考证号最多20位', emptyMsg = '请填写准考证号') => {
    if ((admissionCard === null) || (admissionCard === '')) {
      return { msg: emptyMsg, status: false }
      // } else if (isNaN(admissionCard)) {
    } else if (!/^[0-9]+[0-9]*$/.test(admissionCard)) {
      return { msg: errorMsg, status: false }
    } else if (admissionCard.length > length) {
      return { msg: errorLengthMsg, status: false }
    } else {
      return { msg: correctMsg, status: true }
    }
  },
  //标题的校验
  'titleCheck': (value, length, correctMsg = '符合非空字段规则校验', errorLengthMsg = '不符合最大长度规则校验', emptyMsg = '不符合非空字段规则校验') => {
    if (value === '') {
      return { msg: emptyMsg, status: false }
    } else if (value.length >= length) {
      return { msg: errorLengthMsg, status: false }
    } else {
      return { msg: correctMsg, status: true }
    }
  },
}



// WEBPACK FOOTER //
// ./src/utils/checkRules.js